export enum Question {
  FavoritePetName = "Favorite pet's name?",
  FavoriteMovie = "Favorite movie?",
  AnniversaryDate = "Anniversary date [dd.mm.yyyy]?",
  FathersMiddleName = "Father's middle name?",
  SpousesMiddleName = "Spouse's middle name?",
  FirstChildsMiddleName = "First child's middle name?",
  HighSchoolName = "High school name?",
  FavoriteTeacherName = "Favorite teacher's name?",
  FavoriteSportsTeam = "Favorite sports team?",
  FavoriteCarsName = "Favorite car's name?",
}

export const questions: Question[] = [
  Question.FavoritePetName,
  Question.FavoriteMovie,
  Question.AnniversaryDate,
  Question.FathersMiddleName,
  Question.SpousesMiddleName,
  Question.FirstChildsMiddleName,
  Question.HighSchoolName,
  Question.FavoriteTeacherName,
  Question.FavoriteSportsTeam,
  Question.FavoriteCarsName,
];

export interface ISecurityQuestionData {
  question: Question | '';
  answer: string;
}

export interface IErrorMessage {
  condition: boolean;
  message: string;
  appliesTo?: Question[];
}

export interface IErrorMessageList {
  [key: string]: IErrorMessage;
}
